import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const CloseBigIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.365038 0.365038C0.851754 -0.121679 1.6402 -0.121679 2.12692 0.365038L8 6.23812L13.8731 0.365038C14.3598 -0.121679 15.1482 -0.121679 15.635 0.365038C16.1217 0.851754 16.1217 1.6402 15.635 2.12692L9.76188 8L15.635 13.8731C16.1217 14.3598 16.1217 15.1482 15.635 15.635C15.1482 16.1217 14.3598 16.1217 13.8731 15.635L8 9.76188L2.12692 15.635C1.6402 16.1217 0.851754 16.1217 0.365038 15.635C-0.121679 15.1482 -0.121679 14.3598 0.365038 13.8731L6.23812 8L0.365038 2.12692C-0.121679 1.6402 -0.121679 0.851754 0.365038 0.365038Z'
      fill={color} />
  </svg>
)

export default CloseBigIcon
